import { PeopleSearchProfile } from "../../types/peopleSearch.ts";
import { PEOPLE_SEARCH_SET_WORKERS } from "./actions.ts";

type PeopleSearchState = {
  workers: PeopleSearchProfile[];
};

const INITIAL_STATE: PeopleSearchState = {
  workers: [],
};

type Action = {
  type: string;
  payload?: any;
};

export const peopleSearchReducer = (
  state: PeopleSearchState = INITIAL_STATE,
  action: Action
): PeopleSearchState => {
  switch (action.type) {
    case PEOPLE_SEARCH_SET_WORKERS:
      return {
        ...state,
        workers: action.payload ?? [],
      };
    default:
      return state;
  }
};

export default peopleSearchReducer;

